import { render, staticRenderFns } from "./naj-button.vue?vue&type=template&id=5bab1df8&scoped=true&"
import script from "./naj-button.vue?vue&type=script&lang=js&"
export * from "./naj-button.vue?vue&type=script&lang=js&"
import style0 from "./naj-button.vue?vue&type=style&index=0&id=5bab1df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab1df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
